var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.3 555.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    width: 603.3,
    height: 558.3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M266.3,238.9v-1.8h-37v1.8c4.5,0,9.4.8,13.1,10.7l31.1,84.4h1.9l5.9-16.1-23.4-67.2c-.1-1-3.9-11.8,8.4-11.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.1,238.9v-1.8h-37v1.8c4.7,0,9.2.8,13.1,10.7l32.6,84.4h1.9l5.8-16.4-24.6-66.9c-.4-1-3.9-11.8,8.3-11.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9,333.1v1.9c-26.4-2.5-39.2-23.1-39.2-48.7s12.8-47.5,39.2-50.1v1.9c-13.8,2.3-23.4,14.7-23.4,48.2s9.6,44.7,23.4,46.8ZM373.7,335v-1.9c13.8-2.1,23.5-13.2,23.5-46.8s-9.8-45.8-23.5-48.2v-1.9c26.6,2.6,39.5,24.5,39.5,50.1s-12.9,46.2-39.5,48.7Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 297.6,
    cy: 277.6,
    r: 182.4,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.9,
    y: 149.7,
    width: 255.5,
    height: 255.5,
    transform: "translate(283.4 -129.2) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.9,
    y: 149.7,
    width: 255.5,
    height: 255.5,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.6 73.3 138.6 149.9 99.4 321.9 209.4 459.9 385.9 459.9 495.9 321.9 456.6 149.9 297.6 73.3",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer_4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 305.2,
    cy: 242.4,
    r: 7.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.2,
    cy: 242.4,
    r: 4.9,
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.3,
    y: 247,
    width: 2.3,
    height: 41,
    transform: "translate(113.8 -88.2) rotate(20.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.6,
    y: 232.1,
    width: 1.9,
    height: 20.7,
    transform: "translate(531.9 -47.1) rotate(90)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWo);
export default __webpack_public_path__ + "static/media/wo.d238a6b780ee02ad52d568007090be42.svg";
export { ForwardRef as ReactComponent };